module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('label', {
    attrs: {
      "for": "messageEdit"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "messageEdit",
      "placeholder": "Enter message"
    },
    domProps: {
      "value": _vm.message
    },
    on: {
      "input": function($event) {
        return _vm.$emit('messageChange', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sel1"
    }
  }, [_vm._v("Severity")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    },
    domProps: {
      "value": _vm.severity
    },
    on: {
      "change": function($event) {
        return _vm.$emit('severityChange', $event.target.value)
      }
    }
  }, [_c('option', [_vm._v("Info")]), _vm._v(" "), _c('option', [_vm._v("Warning")]), _vm._v(" "), _c('option', [_vm._v("Danger")]), _vm._v(" "), _c('option', [_vm._v("Success")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29c392a1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29c392a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/notifications/notification-editor.vue.html
// module id = 1088
// module chunks = 0